module.exports = __webpack_public_path__ + "media/images/illustrations/unit_sizes/10x30_small-251d02ffede00c19aa9db4025e62642b.png";